import { render, staticRenderFns } from "./AuthTermsAndConditions.vue?vue&type=template&id=b036015a&"
import script from "./AuthTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./AuthTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports